export enum SlideBuilderSectionColumn {
  LEFT = 'left',
  RIGHT = 'right',
  SINGLE = 'single'
}
